import React, { useEffect, useRef, useState } from 'react';
import StackIcon from 'tech-stack-icons';
import TechStackIcon from '../SvgIcons/TechStackIcon';

const Tags = ({ data, tech_stack = false, showCount = true, showLabels = false, showIcon = true, wrap = true }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const checkIconExists = (name) => {
    try {
      return StackIcon({ name });
    } catch (error) {
      return false;
    }
  };

  if (!data || data.length === 0) return null;

  const RenderIcon = ({ item, index, isFirstIcon }) => {
    const labelRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
      const el = labelRef.current;
      if (el) {
        setIsTruncated(el.scrollWidth > el.clientWidth);
      }
    }, [item.label]);

    const shouldShowTooltip = (tech_stack && !showLabels) || (!tech_stack && isTruncated);

    return (
      <div
        className="font-semibold relative flex items-center justify-center"
        style={{
          backgroundColor: '#ebebeb',
          borderRadius: '24px',
          fontSize: '12px',
          padding: '6px 12px',
          height: '32px',
          maxWidth: '230px',
          position: 'relative',
          margin: '0 4px',
        }}
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        {/* Icon (for tech stack) */}
        {showIcon && (
          <div className="flex items-center justify-center" style={{ width: '16px', marginRight: showLabels ? '8px' : '0' }}>
            {checkIconExists(item.label?.toLowerCase().replace(/[\s\d.:]+/g, '')) ? (
              <StackIcon name={item.label?.toLowerCase().replace(/[\s\d.:]+/g, '')} />
            ) : (
              <TechStackIcon />
            )}
          </div>
        )}

        {/* Label */}
        {showLabels && (
          <span
            ref={labelRef}
            className="flex-shrink-0"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'inline-block',
              maxWidth: '100%',
            }}
          >
            {item.label}
          </span>
        )}

        {/* Hover popover */}
        {isFirstIcon && hoveredIndex === index && shouldShowTooltip && (
          <div className="hover-label" style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            padding: '4px 8px',
            borderRadius: '4px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            zIndex: 10,
            whiteSpace: 'normal',
            width: 'max-content',
            maxWidth: '400px',
            overflowWrap: 'break-word',
          }}>
            {item.label}
          </div>
        )}
      </div>
    );
  };

  const renderCountChip = (count) => (
    <div
      className="cursor-pointer font-semibold relative flex items-center justify-center w-full"
      style={{
        backgroundColor: '#ebebeb',
        borderRadius: '24px',
        fontSize: '12px',
        padding: '6px 12px',
        margin: '0 4px',
        height: '32px',
      }}
      onMouseEnter={() => setHoveredIndex('count')}
      onMouseLeave={() => setHoveredIndex(null)}
    >
    {`+${count}`}
    {hoveredIndex === 'count' && (
      <div className="hover-list" style={{
        fontSize: '12px',
        position: 'absolute',
        top: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'white',
        padding: '12px',
        borderRadius: '4px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        zIndex: 10,
        width: 'max-content',
        maxWidth: '300px',
        maxHeight: '200px',
        overflowY: 'auto',
      }}>
        {data.slice(1).map((item, index) => (
          <div key={index} className="flex items-center justify-start" style={{ margin: '8px 0' }}>
            {showIcon && (
              <div className="flex items-center justify-center" style={{ width: '16px', marginRight: '12px' }}>
                {checkIconExists(item.label?.toLowerCase().replace(/[\s\d.:]+/g, '')) ? (
                  <StackIcon name={item.label?.toLowerCase().replace(/[\s\d.:]+/g, '')} />
                ) : (
                  <TechStackIcon />
                )}
              </div>
            )}
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    )}

    </div>
  );

  const containerClass = !showCount && showLabels ? '' : 'flex items-center flex-wrap';

  const contentStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: showCount ? '4px' : '8px',
    paddingBottom: '8px',
    flexWrap: wrap ? 'wrap' : 'initial',
  };

  return (
    <div className={containerClass}>
      <div style={contentStyle}>
        {showCount ? (
          <>
            <RenderIcon item={data[0]} index={0} isFirstIcon />
            {data.length > 1 && renderCountChip(data.length - 1)}
          </>
        ) : (
          <>
            {data.map((item, index) => (
              <RenderIcon key={index} item={item} index={index} isFirstIcon={index === 0} />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default Tags;
